export const REX_SOFTWARE_EMAIL_TEMPLATE = {
  to: 'support@rexsoftware.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello Rex Software,

Could you please enable Snug as an upload destination for our agency for our Rex Account(s):

- <Agency Name> (<Rex Account ID>)

Please provide the Agency ID for Snug to use.

Thank you,

Head of Property Management`,
}
